var _rect, _rect2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImageEmpty(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 122,
    viewBox: "0 0 142 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 121.149,
    width: 120,
    height: 140,
    rx: 5,
    transform: "rotate(-90 1 121.149)",
    stroke: "#B8C1CB",
    strokeLinecap: "round",
    strokeDasharray: 6
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6829_5101",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 54,
    y: 45,
    width: 34,
    height: 33
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 45.1487,
    width: 33.6842,
    height: 32,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6829_5101)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.5258 50.1487H62.1573C59.9807 50.1487 58.21 51.7799 58.21 53.785V66.5123C58.21 68.5175 59.9807 70.1487 62.1573 70.1487H75.6277C76.1728 70.1487 76.6146 69.7417 76.6146 69.2396C76.6146 68.7375 76.1728 68.3305 75.6277 68.3305H71.993L69.724 65.6189L76.9143 57.194L81.7546 62.1222C82.0283 62.4012 82.4603 62.4958 82.8411 62.3607C83.2218 62.2254 83.4731 61.8882 83.4731 61.5123V53.785C83.4731 51.7799 81.7024 50.1487 79.5258 50.1487ZM81.4993 59.1526L77.593 55.1751C77.398 54.9764 77.1173 54.8667 76.8271 54.8765C76.5366 54.8859 76.2652 55.0127 76.0854 55.2232L68.4809 64.1334L65.8993 61.0482C65.7126 60.825 65.4238 60.6941 65.1178 60.6941C65.1176 60.6941 65.1174 60.6941 65.1172 60.6941C64.8111 60.6943 64.5222 60.8253 64.3356 61.0489L62.1638 63.6497C61.8315 64.0478 61.9123 64.6185 62.3442 64.9246C62.7763 65.2309 63.3958 65.1563 63.7283 64.7584L65.1185 63.0933L69.5009 68.3305H62.1572C61.069 68.3305 60.1835 67.5148 60.1835 66.5123V53.785C60.1835 52.7826 61.069 51.9669 62.1572 51.9669H79.5257C80.6139 51.9669 81.4993 52.7826 81.4993 53.785V59.1526Z",
    fill: "#6A7481"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.5261 53.1487C62.7847 53.1487 61.3682 54.2701 61.3682 55.6487C61.3682 57.0273 62.7847 58.1487 64.5261 58.1487C66.2674 58.1487 67.684 57.0273 67.684 55.6487C67.684 54.2701 66.2674 53.1487 64.5261 53.1487ZM64.5257 56.482C63.9454 56.482 63.4731 56.1082 63.4731 55.6487C63.4731 55.1892 63.9454 54.8154 64.5257 54.8154C65.1061 54.8154 65.5784 55.1892 65.5784 55.6487C65.5784 56.1082 65.1061 56.482 64.5257 56.482Z",
    fill: "#6A7481"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.457 63.864C81.4542 63.8612 81.4515 63.8582 81.4488 63.8554C81.0107 63.3996 80.428 63.1487 79.8078 63.1487C79.1894 63.1487 78.6084 63.3981 78.1708 63.8512L76.3814 65.6745C76.017 66.0457 76.013 66.652 76.3725 67.0284C76.7319 67.4048 77.3187 67.4091 77.6831 67.0377L78.881 65.8174V71.1912C78.881 71.7201 79.2959 72.1487 79.8078 72.1487C80.3198 72.1487 80.7347 71.7201 80.7347 71.1912V65.8465L81.8811 67.0699C82.0628 67.264 82.3049 67.3614 82.5471 67.3614C82.7793 67.3614 83.0118 67.2719 83.1917 67.092C83.5596 66.7241 83.569 66.1181 83.2129 65.7381L81.457 63.864Z",
    fill: "#6A7481"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageEmpty);
export default __webpack_public_path__ + "static/media/image-empty.8c976cfe6e520163b990bfdc0465dff1.svg";
export { ForwardRef as ReactComponent };